import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Slide from '@mui/material/Slide';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import Button from '@mui/material/Button';
import CustomerOrder from '../CustomerOrder';
import OrderListTable from './OrderListTable';

export default function OrderHistory(props) {
    const [orders, setOrders] = React.useState([]);
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    React.useEffect(() => {
        loadOrder(); // only called once
    }, []);

    function loadOrder() {
        setIsFetching(true);

        TokenService.customerPost('', 'MyHistory')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);

                    setOrders(JSON.parse(jsonData.Orders));

                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function buildOrders() {
        if (orders.length == 0) {
            return <div>You do not have any Completed Orders</div>
        }
        else {
            return <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Paid'  />
        }
    }


    return (<div>
        {isFetching ? buildSkeleton() :
            buildOrders()
        }
    </div>)
}